import { assoc, compose, filter, map, pick } from 'ramda'
import { shouldRenderReply } from '@btime/helpers'

import { cleanDynamicValueV2 } from './dynamicInputs'

const flattenBlockReplies = replies => {
  const allReplies = replies.reduce((replies, reply) => {
    let blockReplies = []
    if (reply.question?.type?.name === 'block') {
      blockReplies = (reply.value || []).reduce(
        (list, block, index) => [...list, ...block.map(reply => assoc('blockIndex', index, reply))],
        []
      )
    }
    return [...replies, reply, ...blockReplies]
  }, [])
  return allReplies
}

const isInformative = reply => reply.question?.type?.name === 'informative'

export const cleanRepliesForApi = compose(
  filter(item => item.value !== undefined || isInformative(item)),
  map(
    compose(
      pick(['questionId', 'value', 'documents', 'notes', 'blockIndex']),
      reply =>
        assoc(
          'documents',
          map(doc => ({ id: doc.id || doc.documentId, description: doc.description }), reply.documents || []),
          reply
        ),
      item => assoc('value', cleanDynamicValueV2(item.value, item.question?.type?.name), item)
    )
  ),
  replies => replies.filter(reply => shouldRenderReply(reply, replies) || reply.blockIndex >= 0),
  flattenBlockReplies
)
